export default __webpack_public_path__ + "static/media/whatsapp.b3dcfe74.svg";